import React from 'react';
// import { Helmet } from 'react-helmet';

// styles
import styles from "./ContactUs.module.css"

const ContactUs = ({ bannerDataTwo, phoneData }) => {

    return (
        <>
            {/* <Helmet>
                <title>تماس با ما</title>
                <meta name="description" content="خرید , فروش , اجاره و رهن ملک در تبریز" />
                <meta name="keywords" content=
                    "اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز, اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز" />
                <meta content="index , follow" name="robots" />
                <meta name="og:title" content="خرید , فروش , اجاره و رهن ملک در تبریز" />
                <meta name="description" content="خرید , فروش , اجاره و رهن ملک در تبریز" />
                <meta name="og:description" content="خرید , فروش , اجاره و رهن ملک در تبریز" />
                <meta rel="canonical" href="https://azrmelk.com/تماس-با-ما" />
                <meta content="website" property="og:type" />
                <meta content="https://azrmelk.com" name="twitter:site" />
                <meta content="https://azrmelk.com/تماس-با-ما" property="og:url" />
            </Helmet> */}
            
            <div className="container-fluid">
                <div
                    className="w-100 d-flex justify-content-center flex-wrap align-items-center my-5 me-3 px-md-5 px-0 "
                    dir="rtl"
                >
                    <div className={`d-flex align-items-center justify-content-between position-relative ${styles.container}`}>
                        <div className={`d-flex flex-column justify-content-center align-items-start flex-wrap px-3 px-md-0 ${styles.text_container}`}>
                            <h2 className={`${styles.title}`}>
                                {bannerDataTwo?.title}
                            </h2>
                            <p className={`${styles.description}`}>
                                {bannerDataTwo?.content}
                            </p>
                            <div className={styles.btn_container}>
                                <a href={`tel: ${phoneData?.phoeNumber}`} className={`d-flex align-items-center justify-content-center ${styles.btn}`}>
                                    تماس با ما
                                </a>
                            </div>
                        </div>

                        <div className={styles.icons_container}>
                            <div className={styles.icon2}>
                                {/* <img src={icon2} alt="icon" /> */}
                            </div>
                            <div className={styles.icon1}>
                                {/* <img src={icon1} alt="icon" /> */}
                                <div className="d-flex flex-column align-items-center justify-content-center">
                                    <div className='d-flex flex-column align-items-center justify-content-center'>
                                        <h3 className={styles.icon_text}>شماره تماس</h3>
                                        <p className={styles.icon_text}>{phoneData?.landlinePhone?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}</p>
                                    </div>
                                    <div className='d-flex flex-column align-items-center justify-content-center'>
                                        <h3 className={styles.icon_text}>ایمیل</h3>
                                        <p className={styles.icon_text}>{phoneData?.email}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.responsive_text}>
                        <div className='d-flex align-items-center justify-content-center'>
                            <p className={`ms-2 ${styles.icon_text}`}>شماره تماس</p>
                            <p className={styles.icon_text}>{phoneData?.landlinePhone?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}</p>
                        </div>
                        <div className='d-flex align-items-center justify-content-center'>
                            <p className={`ms-2 ${styles.icon_text}`}>ایمیل</p>
                            <p className={styles.icon_text}>{phoneData?.email}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactUs;